import React from 'react';

import styled from 'styled-components';

import { userMessageBubbleStyles } from './message_styles';

type Props = {
  content: string;
};

export function UserMessage({ content }: Props) {
  return (
    <Container>
      <Bubble>{content}</Bubble>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const Bubble = styled.div`
  ${userMessageBubbleStyles}
`;
